import { Bike, Minus, Plus } from "lucide-react";
import { useMarket } from "../../lib/market";

export const OWN_BIKE = "Own bike";
const ON_REQUEST = "Hire bike (price on request)";

export const bikeOptionsFor = (hire) => [...((hire?.length ? hire : [{ name: ON_REQUEST }])), { name: OWN_BIKE }];

function Stepper({ value, onChange, testid }) {
  const btn = "w-8 h-8 rounded-sm border border-sand-dark bg-white flex items-center justify-center disabled:opacity-40";
  return (
    <div className="flex items-center gap-2">
      <button type="button" className={btn} onClick={() => onChange(Math.max(0, value - 1))} disabled={!value} data-testid={`${testid}-minus`}><Minus className="w-3.5 h-3.5" /></button>
      <span className="w-6 text-center font-semibold text-sm" data-testid={`${testid}-qty`}>{value}</span>
      <button type="button" className={btn} onClick={() => onChange(Math.min(20, value + 1))} data-testid={`${testid}-plus`}><Plus className="w-3.5 h-3.5" /></button>
    </div>
  );
}

export default function BikePicker({ options, value, onChange, riders }) {
  const { price } = useMarket();
  const set = (name) => (qty) => onChange({ ...value, [name]: qty });
  const total = Object.values(value).reduce((a, b) => a + b, 0);
  const max = parseInt(riders, 10);
  return (
    <div data-testid="enq-bikes">
      <p className="font-mono text-[11px] uppercase tracking-widest text-ink-secondary mb-1.5 flex items-center gap-1.5"><Bike className="w-3.5 h-3.5" /> Your bikes (how many riders on each)</p>
      <ul className="border border-sand-dark rounded-sm bg-white divide-y divide-sand-dark">
        {options.map((o, i) => (
          <li key={o.name} className="flex items-center justify-between gap-3 px-3 py-2.5">
            <div className="min-w-0">
              <p className="text-sm font-medium">{o.name === OWN_BIKE ? "I'll bring my own bike" : o.name}</p>
              {o.price ? <p className="text-xs text-ink-muted">{price(o.price)} per rider</p> : o.name !== OWN_BIKE && <p className="text-xs text-ink-muted">We'll confirm the best bike and price</p>}
            </div>
            <Stepper value={value[o.name] || 0} onChange={set(o.name)} testid={`enq-bike-${i}`} />
          </li>
        ))}
      </ul>
      {max > 0 && total > 0 && total !== max && !String(riders).includes("+") && (
        <p className="text-xs text-terracotta mt-1.5" data-testid="enq-bikes-mismatch">You've chosen {total} bike{total === 1 ? "" : "s"} for {max} rider{max === 1 ? "" : "s"}. That's fine if it's intended; just tell us in the comments.</p>
      )}
    </div>
  );
}
